export default (way: number|null|undefined, wayTime: string|null|undefined) => {
  if (way) {
    return `${way} м`;
  }
  return `${wayTime}`;
};
